import React from 'react';

import {
  StatePanelActions,
  StatePanelHeading,
  StatePanelMark,
  StatePanelMessage,
  StatePanelRoot,
  StatePanelTone,
} from './state-panel.styled-components';

export type { StatePanelTone } from './state-panel.styled-components';

type HeadingLevel = 1 | 2;

const useFocusOnMount = (focusOnMount: boolean) => {
  const headingRef = React.useRef<HTMLHeadingElement>(null);

  React.useEffect(() => {
    if (focusOnMount) {
      headingRef.current?.focus();
    }
  }, [focusOnMount]);

  return headingRef;
};

interface StatePanelProps {
  action?: React.ReactNode;
  focusOnMount?: boolean;
  heading?: string;
  headingLevel?: HeadingLevel;
  icon: React.ReactNode;
  message: string;
  tone: StatePanelTone;
}

export const StatePanel: React.FC<StatePanelProps> = ({
  action,
  focusOnMount = false,
  heading,
  headingLevel = 1,
  icon,
  message,
  tone,
}) => {
  const headingRef = useFocusOnMount(focusOnMount && Boolean(heading));

  return (
    <StatePanelRoot>
      <StatePanelMark $tone={tone} aria-hidden>
        {icon}
      </StatePanelMark>

      {heading ? (
        <StatePanelHeading
          as={`h${headingLevel}`}
          ref={headingRef}
          tabIndex={-1}
        >
          {heading}
        </StatePanelHeading>
      ) : null}

      <StatePanelMessage>{message}</StatePanelMessage>

      {action ? <StatePanelActions>{action}</StatePanelActions> : null}
    </StatePanelRoot>
  );
};
